import React from "react";
import ICalendarFactory from "./planning/other/calendar/ICalendarFactory.tsx";


interface TimePickerProps {
  range: { start: number, end: number };
  value: { hour: number, minute: number }
  step: number;
}

const TimePicker = (props: TimePickerProps) => {
  const range = props.range ? props.range : { start: 0, end: 24 };
  const value = props.value;
  const step = props.step ? props.step : 30;

  const formatValue = ( value: number ) : string => { return (value < 10 ? '0' : '') + value}

  return (
    <div className="debug inline-flex p-1 w-24 justify-center">
      <div className="w-full text-center">
        <select>
          {value != null && <option selected disabled hidden value={value.hour}>{formatValue(value.hour)}</option>}
          {ICalendarFactory.hoursByRange(range).reverse().map(hour => (
            <option className="" value={hour}>{formatValue(hour)}</option>
          ))}
        </select>
      </div>
      :
      <div className="w-full text-center">
        <select>
          {value != null && <option selected disabled hidden value={value.minute}>{formatValue(value.minute)}</option>}
          {Array.from({ length: Math.floor(60 / step) }, (_, i) => i * step).reverse().map(minutes => (
            <option className="" value={minutes}>{formatValue(minutes)}</option>
          ))}
        </select>
      </div>
    </div>
  );
}

export default TimePicker;
